export default __webpack_public_path__ + "static/media/paynetStores.03cb70a7.gif";